import { Row, Col } from "antd";
import { Typography, TextField } from "@mui/material";
import moment from 'moment';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";

export const HeaderView = (props) => {
    const { classes, clsx, form, status, view, error, changeHandler, locationDetails, customObject, receivedView, idNamingConversion } = props;

    return (
        <>
            <Row gutter={50}>
                <Col xxl={18} xl={18} lg={18} md={24} sm={24} xs={24}>
                    <Row gutter="30">
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Stock Transfer Number</Typography>
                            <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.serialNo || '---'} </Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            <span className={clsx(classes.statusButton, { [classes.submittedButton]: status === 'SHIPPED' }, { [classes.confirmedButton]: status === 'RECEIVED' })}>{status || 'CREATED'}</span>
                        </Col>

                    </Row>
                    <Row gutter="30">
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Location</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {form?.location?.name || '---'}
                                    </Typography>
                                </> : <AutoCompleteComponent
                                    name={["Location ", <span key={"Location"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Location' }]}
                                    details={locationDetails}
                                    id={idNamingConversion('Location', 'stockTransfer', 'DropDown')}
                                    parentValue={customObject(locationDetails, form?.locationId)}
                                    onChange={(data) => changeHandler(data, 'locationId', 'location')}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                    parentError={error?.locationId}
                                />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>To Location</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {form?.toLocation?.name || '---'}
                                    </Typography>
                                </> : <AutoCompleteComponent
                                    name={["To Location ", <span key={"To Location"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Location' }]}
                                    details={locationDetails}
                                    id={idNamingConversion('Location', 'stockTransfer', 'DropDown')}
                                    parentValue={customObject(locationDetails, form?.toLocationId)}
                                    onChange={(data) => changeHandler(data, 'toLocationId', 'toLocation')}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                    parentError={error?.toLocationId}

                                />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Shipped Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.shippedDate ? moment(form.shippedDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> :
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                tabIndex={-1}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.shippedDate || null}
                                                label="Shipped Date"
                                                PopperProps={{
                                                    className: classes.dateAdjust,
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('Shipped Date', 'stockTransfer', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'shippedDate');
                                                    } else {
                                                        changeHandler(newValue, 'shippedDate');
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                {
                                    view ?
                                        <>
                                            {receivedView ?
                                                <>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Received Date</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                        {form.receivedDate ? moment(form.receivedDate).format('DD MMM YYYY') : '---'}
                                                    </Typography>
                                                </> : <LocalizationProvider
                                                    dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        tabIndex={-1}
                                                        fullWidth
                                                        slots={{
                                                            openPickerIcon: DateIcon
                                                        }}
                                                        views={['year', 'month', 'day']}
                                                        value={form?.receivedDate || null}
                                                        label="Received Date"
                                                        PopperProps={{
                                                            className: classes.dateAdjust,
                                                        }}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                id: idNamingConversion('Received Date', 'stockTransfer', 'TextField'),
                                                                autoComplete: 'one-time-code'
                                                            },
                                                        }}
                                                        // minDate={new Date(y, m, 1)}
                                                        // maxDate={new Date(y, m + 1, 0)}
                                                        format="dd/MM/yyyy"
                                                        onChange={(newValue, newError) => {
                                                            if (newError?.validationError || newValue === null) {
                                                                changeHandler(new Date(), 'receivedDate');
                                                            } else {
                                                                changeHandler(newValue, 'receivedDate');
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            }
                                        </> :
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                tabIndex={-1}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.receivedDate || null}
                                                label="Received Date"
                                                PopperProps={{
                                                    className: classes.dateAdjust,
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('Received Date', 'stockTransfer', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // minDate={new Date(y, m, 1)}
                                                // maxDate={new Date(y, m + 1, 0)}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'receivedDate');
                                                    } else {
                                                        changeHandler(newValue, 'receivedDate');
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row gutter="30">
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.margin35t, classes.bold)}>Transport Details</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Driver Name </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.driverName || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Driver Name "]}
                                        fullWidth
                                        name={"driverName"}
                                        id={idNamingConversion('Driver Name', 'stockTransfer', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        variant={'standard'}
                                        value={form?.driverName || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e.target.value, 'driverName')}
                                    />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Vehicle Number</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.vehicleNumber || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Vehicle Number "]}
                                        fullWidth
                                        name={"vehicleNumber"}
                                        id={idNamingConversion('Vehicle Number', 'stockTransfer', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        variant={'standard'}
                                        value={form?.vehicleNumber || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e.target.value, 'vehicleNumber')}
                                    />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Mode of Transport</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.modeOfTransport || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Mode of Transport "]}
                                        fullWidth
                                        name={"modeOfTransport"}
                                        id={idNamingConversion('Mode of Transport', 'stockTransfer', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        variant={'standard'}
                                        value={form?.modeOfTransport || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e.target.value, 'modeOfTransport')}
                                    />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Distance</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.distance || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Distance"]}
                                        fullWidth
                                        name={"distance"}
                                        id={idNamingConversion('Distance', 'stockTransfer', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        variant={'standard'}
                                        value={form?.distance || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e.target.value, 'distance')}
                                    />
                            }
                        </Col>
                    </Row>
                    <Row gutter="30">
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Created Date</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.createTs ? moment(form.createTs).format('DD MMM YYYY') : '---'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>User Name</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createdBy || '---'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Shipped By</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.shippedBy || '---'}</Typography>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Received By</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.receivedBy || '---'}</Typography>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}